/**
 * If the distance is greater than 1000 meters, return the distance in kilometers, otherwise return the distance in meters.
 *
 * @param distanceInMeters - The distance in meters units.
 */
export const calcDistanceString = (distanceInMeters: number): string => {
  if (distanceInMeters > 1000) {
    return `${(distanceInMeters / 1000).toFixed(0)} km`
  }

  return `${distanceInMeters.toFixed(0)} m`
}
